import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../../../app/store';
import fetchAPI from "../../../common/fetchAPI";
import { ExpenseTypeStateClass } from "./interfaces/expensetypeStateClass";
import { sortData } from "../../../common/timeLiveFunction";
const initialState: ExpenseTypeStateClass = {
    isLoading: false,
    status: 'idle',
    expensetypeList: [],
    selectedRecord: {},
    isReload : false,
    sortOrder: 'asc',
    sortColumn: 'ExpenseType',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        expensetype: ExpenseTypeStateClass;
    },
}

export const getAccountExpenseTypesAsync = createAsyncThunk
<any, void, IThunkApi>
(
'expensetype/getAccountExpenseTypes',
async (arg, thunkApi) => {
    const response = await fetchAPI('api/expensetypes', 'Get','',true,'0c077428-c7f6-499f-b985-fc9f4740aea9');
    const json = await response.json();
    return json;
}
)

export const getAccountExpenseTypeByAccountTaxZoneIdAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'expensetype/getAccountExpenseTypeByAccountTaxZoneId',
    async (arg, thunkApi) => {
        const response = await fetchAPI('api/v2/ExpenseTypes/GetAccountExpenseTypesByAccountTaxZoneId/' + arg, 'Get', '', true, '0c077428-c7f6-499f-b985-fc9f4740aea9');
        const json = await response.json();
        return json;
    }
)

export const getAccountExpenseTypeByAccountExpenseTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensetype/getAccountExpenseTypeByAccountExpenseTypeId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/expensetypes/' + arg, 'Get', '', true, '0c077428-c7f6-499f-b985-fc9f4740aea9');
            const json = await response.json();
            return json;
        }
    )

    export const addAccountExpenseTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensetype/addAccountExpenseType',
        async (arg, thunkApi) => {
            console.log('hfhff', arg)

            const response = await fetchAPI('api/v2/ExpenseTypes/', 'POST', arg, true, '0c077428-c7f6-499f-b985-fc9f4740aea9');
            const json = await response.json();
            return json;
        }
    )

    export const updateAccountExpenseTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensetype/updateAccountExpenseType',
        async (arg, thunkApi) => {
            const { AccountExpenseTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/ExpenseTypes/' + AccountExpenseTypeId, 'PUT', argWithoutId, true, '0c077428-c7f6-499f-b985-fc9f4740aea9');
            const json = await response.json();
            return json;  

        
        }
        )


export const deleteAccountExpenseTypeAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'expensetype/deleteAccountExpenseType',
    async (arg, thunkApi) => {
        const response = await fetchAPI('api/v2/ExpenseTypes/' + arg, 'DELETE', '', true, '0c077428-c7f6-499f-b985-fc9f4740aea9');
        const json = await response.json();
        return json;
    }
)

export const getAccountExpenseTypeByAccountExpenseTypeIdAndAccountTaxZoneIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensetype/GetAccountExpenseTypesByAccounExpenseTypeId',
        async (arg, thunkApi) => {
            const { AccountExpenseTypeId, AccountTaxZoneId } = arg;
            const response = await fetchAPI('api/v2/ExpenseTypes/GetAccountExpenseTypesByAccounExpenseTypeId/' + AccountExpenseTypeId + '/' + AccountTaxZoneId, 'Get', '', true, '3d6cf151-f54c-4b2a-bc9f-102b3f0835f6');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordExpenseTypeAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "expensetype/DeleteAllSelectedRecordExpenseType",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/ExpenseTypes/DeleteSelected/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        
        }
    )



export const expensetypeSlice = createSlice({
    name: 'expensetype',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.expensetypeList.findIndex((item) => item.AccountExpenseTypeId == action.payload);
            const newArray = [...state.expensetypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.expensetypeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.expensetypeList.findIndex((item) => item.AccountExpenseTypeId == action.payload);
            const newArray = [...state.expensetypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.expensetypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.expensetypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.expensetypeList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.expensetypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.expensetypeList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.expensetypeList;
            state.expensetypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getAccountExpenseTypesAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(getAccountExpenseTypesAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.expensetypeList = payload;
            state.isReload = false;
            state.selectedRecord = {};
        })
        .addCase(getAccountExpenseTypesAsync.rejected, (state) => {
            state.status = 'failed';
        })
        .addCase(getAccountExpenseTypeByAccountTaxZoneIdAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(getAccountExpenseTypeByAccountTaxZoneIdAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
                state.expensetypeList = payload.Data;
                state.expensetypeList.map((item: any) => {
                    item.isSelected = 0
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
        })
        .addCase(getAccountExpenseTypeByAccountTaxZoneIdAsync.rejected, (state) => {
            state.status = 'failed';
        })      
        .addCase(addAccountExpenseTypeAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(addAccountExpenseTypeAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;

        })
        .addCase(addAccountExpenseTypeAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;

        })  
        .addCase(updateAccountExpenseTypeAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(updateAccountExpenseTypeAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;

        })
        .addCase(updateAccountExpenseTypeAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;

        })
        .addCase(deleteAccountExpenseTypeAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(deleteAccountExpenseTypeAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;

        })
        .addCase(deleteAccountExpenseTypeAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;

        })
        .addCase(getAccountExpenseTypeByAccountExpenseTypeIdAndAccountTaxZoneIdAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(getAccountExpenseTypeByAccountExpenseTypeIdAndAccountTaxZoneIdAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isLoading = false;
            state.selectedRecord = payload.Data[0];
        })
        .addCase(getAccountExpenseTypeByAccountExpenseTypeIdAndAccountTaxZoneIdAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;

        })

        .addCase(deleteAllSelectedRecordExpenseTypeAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(deleteAllSelectedRecordExpenseTypeAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;

        })
        .addCase(deleteAllSelectedRecordExpenseTypeAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;

        })
    }
})

export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState,updatePagination,updateSorting
} = expensetypeSlice.actions
export const ExpenseTypeState = (state: RootState) => state.expensetype
export default expensetypeSlice.reducer